// Registry of every platform-config NamespaceSchema. Configs.tsx looks up
// schemas here by namespace string; missing entries fall back to the raw
// JSON editor.

import type { NamespaceSchema } from './types';
import { advancedSettings } from './advanced-settings';
import { bidSettings } from './bid-settings';
import { dispatchSettings } from './dispatch-settings';
import { bookingSettings } from './booking-settings';
import { carSettings } from './car-settings';
import { currencySettings } from './currency-settings';
import { emailSettings } from './email-settings';
import { enquirySettings } from './enquiry-settings';
import { hostSettings } from './host-settings';
import { mediaSettings } from './media-settings';
import { newsSettings } from './news-settings';
import { paymentSettings } from './payment-settings';
import { pricingSettings } from './pricing-settings';
import { reviewSettings } from './review-settings';
import { siteSettings } from './site-settings';
import { smsSettings } from './sms-settings';
import { socialAuthSettings } from './social-auth-settings';
import { testModeSettings } from './test-mode-settings';
import { userSettings } from './user-settings';
import { walletSettings } from './wallet-settings';

const SCHEMAS: NamespaceSchema[] = [
  advancedSettings,
  bidSettings,
  dispatchSettings,
  bookingSettings,
  carSettings,
  currencySettings,
  emailSettings,
  enquirySettings,
  hostSettings,
  mediaSettings,
  newsSettings,
  paymentSettings,
  pricingSettings,
  reviewSettings,
  siteSettings,
  smsSettings,
  socialAuthSettings,
  testModeSettings,
  userSettings,
  walletSettings,
];

const BY_NAMESPACE = new Map<string, NamespaceSchema>(
  SCHEMAS.map((s) => [s.namespace, s]),
);

export function getSchema(namespace: string): NamespaceSchema | undefined {
  return BY_NAMESPACE.get(namespace);
}

export function listSchemas(): NamespaceSchema[] {
  return SCHEMAS;
}

export type { NamespaceSchema, Field, FieldSection } from './types';
